import React, { useContext, useEffect, useState } from "react";
import { Box, IconButton, Stack, Typography, Button } from "@mui/material";
import { Images } from "../../../assets/common";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import LinearBar from "../../LinearBar";
import TopListPopup from "../../TopListPopup";
import ApiService from "../../../services/api-service";
import { SocketContext } from "../../../context/socket";
import { kFormatter, truncate } from "../../../constants/function";
import { useTranslation } from "react-i18next";
import AddSikiModal from "../../AddSikiModal";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { useDispatch } from "react-redux";
import { getBalance } from "../../../action/balance";
import LivestreamPayPopup from "../../LivestreamPayPopup";
export default function StreamTippers({
  title,
  goal,
  channelName,
  liveUser,
  isOwner,
  goalProgress,
  setStreamTippers,
  isJoined,
  goalDescription,
}) {
  const { t } = useTranslation("common");
  const [totalTip, setTotalTip] = React.useState(0);
  const socket = useContext(SocketContext).Socket;
  const [open, setOpen] = useState(false);
  const [tippers, setTippers] = React.useState([]);
  const [openPayModel, setOpenPayModel] = React.useState(false);
  const [fundingLink, setFundLink] = React.useState(null);
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);
  const [currency, setCurrecy] = React.useState("siki");
  const [newWindow, setNewWindow] = React.useState();

  const getMoonpayLink = async (amount) => {
    if (amount >= 30 && amount <= 20000) {
      try {
        setLoading(true);
        const response = await ApiService.FUNDINGLINK({
          amount: parseInt(amount),
          tag: "time to buy some BTC",
          currency: currency,
        });
        setLoading(false);
        setFundLink(response["result"]);
        handleClose();
      } catch (error) {
        setLoading(false);
      }
    }
  };

  const getPaypalLink = async (amount) => {
    if (amount >= 4.99 && amount <= 20000) {
      try {
        setLoading(true);
        const response = await ApiService.PAYPALLINK({
          amount: amount,
        });
        setLoading(false);
        // setFundLink(response["result"]["links"][1]["href"]);
        setNewWindow(response["result"]["links"][1]["href"]);
        // check response and set the fundlink according to it
        handleClose();
      } catch (error) {
        setLoading(false);
      }
    }
  };

  const getTopTippers = async () => {
    try {
      const response = await ApiService.TOP_TIPPERS(channelName);
      setTippers([...response.result]);
      if (response.result.length > 0) setStreamTippers(true);
    } catch (error) {}
  };
  const openTopTippers = () => {
    getTopTippers();
    setOpen(true);
  };

  const redirect = () => {
    window.open(
      newWindow,
      "_blank",
      "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400"
    );
  };

  React.useEffect(() => {
    getTopTippers();
  }, []);
  React.useEffect(() => {
    setTotalTip(goalProgress);
    if (socket)
      socket.on("totalTips", function (data) {
        if (data.playlistId === channelName) {
          getTopTippers();
          setTotalTip(data?.goalProgress || 0);
        }
      });
    return () => setTippers([]);
  }, [socket]);

  React.useEffect(() => {
    if (newWindow) {
      redirect();
    }
  }, [newWindow]);

  const handleOpen = () => {
    setOpenPayModel(true);
  };
  const handleClose = () => {
    setOpenPayModel(false);
  };

  // console.log("Token::", token);
  // console.log("fundingLink moonpay:", fundingLink);
  return (
    <Box
      id="_streamTippers"
      sx={{
        padding: goal || tippers.length > 0 ? "16px" : 0,
        // width: liveUser > 0 ? "83%" : "96%",
        // transition: "width .2s ease-out ",
      }}
    >
      <Stack
        direction="row"
        justifyContent={!title || !goal ? "end" : "space-between"}
      >
        {!title || !goal ? null : (
          <Stack sx={{ flexGrow: "2", maxWidth: "40%" }} spacing={1}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography title={title}>{truncate(title, 30)}</Typography>
                <IconButton title={goalDescription ? goalDescription : ""}>
                  <InfoOutlinedIcon
                    sx={{ color: "#999999", fontSize: "13px" }}
                  />
                </IconButton>
              </Stack>
              <Stack direction="row" spacing={1} alignItems="center">
                <img
                  style={{ width: "16px", height: "16px" }}
                  src={Images.coin}
                  alt=""
                />
                <Typography className="fs-14" title={goal}>
                  {truncate(kFormatter(goal), 10)}
                </Typography>
              </Stack>
            </Stack>
            <LinearBar value={`${totalTip}%`} color={"#2CF488"} />
            <Typography className="fade-text-60 fs-12">
              {totalTip}% {t("stream.text1")}
            </Typography>
          </Stack>
        )}
        {tippers.length === 0 ? null : (
          <Stack spacing={1} sx={{ alignItems: "center", flexGrow: "3" }}>
            <Typography className="fs-14">{t("stream.text2")}</Typography>
            <Stack
              direction="row"
              alignItems="center"
              spacing={2}
              onClick={() => openTopTippers()}
              className="_cp"
            >
              <Stack direction="row">
                {tippers &&
                  tippers
                    .slice(0, 3)
                    .map((m, index) => (
                      <img
                        key={index}
                        className={"w24 h24 faded-round-border -mr-9"}
                        src={m?.profilePic?.filePath || Images.default_user}
                        alt=""
                      />
                    ))}
              </Stack>
              <Typography className="fs-14 fw-b">
                {tippers.length} {t("stream.text3")}
              </Typography>
            </Stack>
          </Stack>
        )}

        <Stack
          justifyContent="center"
          sx={{
            padding: goal || tippers.length > 0 ? 0 : "16px",
          }}
        >
          <Button
            title={t("nftDetail.nftRow.button4")}
            sx={{
              height: "30px !importent",
              fontWeight: "bold",
            }}
            onClick={() => {
              handleOpen();
            }}
            variant="contained"
            color="primary"
          >
            {t("buySikiTokens")}
          </Button>
        </Stack>
      </Stack>
      {open ? (
        <TopListPopup
          isLiveUser={true}
          title={`${t("topListPopup.title4")} (${tippers.length})`}
          open={open}
          handelClose={() => setOpen(false)}
          isTip={true}
          isArray={true}
          data={tippers}
        />
      ) : null}
      {/* <AddSikiModal open={openPayModel} handleClose={handleClose} /> */}
      <LivestreamPayPopup
        open={openPayModel}
        handleClose={handleClose}
        handleSubmit={(amount, type) => {
          if (type == "moonPay") {
            getMoonpayLink(amount);
          } else {
            getPaypalLink(amount);
          }
        }}
        loading={loading}
      />
      {fundingLink ? (
        <Box className="__moonpay" sx={{ zIndex: "2" }}>
          <CloseOutlinedIcon
            className="_cp"
            color="secondary"
            onClick={() => {
              setFundLink(null);
              setTimeout(() => {
                dispatch(getBalance());
              }, 2000);
            }}
          />
          <iframe
            style={{ height: "100%" }}
            allow="accelerometer; autoplay; camera; gyroscope; payment"
            src={fundingLink}
          >
            <p>Your browser does not support iframes.</p>
          </iframe>
        </Box>
      ) : null}
    </Box>
  );
}
